/**
 * RDL — Retail Document Library.
 *
 * v0.1.54 reshape (DOCUMENTS agent):
 *   - 3-tab landing (My Customers / By Cart / Library) replaces the legacy
 *     filter-chip browser. Library tab is gated to Manager+ / Compliance /
 *     Auditor / Admin.
 *   - Per-CIF and per-cart drill-ins live at `/rdl/cif/:cifId` +
 *     `/rdl/cart/:cartId` and lean on the same DocumentTile / preview /
 *     upload modal stack.
 *   - Inline preview modal (DocumentPreviewModal) replaces the standalone
 *     `/rdl/preview/:documentId` route — preview is now modal-everywhere.
 *   - Persistent "+ Upload document" CTA in every header.
 *
 * Backend status
 * --------------
 * - GET /v3/documents/list       : LIVE (DocumentsFunction.cs).
 * - GET /v3/documents/search     : NEW (DocumentsFunction.cs extended).
 * - GET /v3/documents/types      : NEW.
 * - GET /v3/documents/:id/content: NEW (501 fallback when SP not wired).
 * - POST /v3/documents/upload    : NEW (501 fallback when SP not wired).
 * - DELETE /v3/documents/:id     : NEW (Manager+ on the server).
 *
 * `documentsClient.ts` swallows 501/503 and falls back to the bundled fixture
 * so the surface stays interactive during the SharePoint Sites.Selected
 * grant rollout.
 */

import { Route, Routes } from 'react-router';
import { SignedPacketsPage } from './SignedPacketsPage';
import { CartDrilldown } from './tabs/CartDrilldown';
import './styles/documents.css';

export default function RDL(): JSX.Element {
  return (
    <Routes>
      {/* Signed packets from opening (Bill 2026-10-17); the SharePoint-row library views never held these files. */}
      <Route index element={<SignedPacketsPage />} />
      <Route path="cif/:cifId" element={<SignedPacketsPage />} />
      <Route path="cart/:cartId" element={<CartDrilldown />} />
    </Routes>
  );
}
